(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["milestone-carousel"] && !Shopify.designMode) return;
  try {
    
  class LsMilestoneCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.ls-milestones__track');
      this.prevBtn = this.querySelector('.ls-milestones__arrow--prev');
      this.nextBtn = this.querySelector('.ls-milestones__arrow--next');
      this.dotsWrap = this.closest('.ls-milestones').querySelector('.ls-milestones__dots');
      this.dots = this.dotsWrap ? Array.from(this.dotsWrap.querySelectorAll('.ls-milestones__dot')) : [];
      this.slides = Array.from(this.querySelectorAll('.ls-milestones__slide'));

      this.isDragging = false;
      this.dragStartX = 0;
      this.dragStartScroll = 0;
      this.dragMoved = false;

      this.onScroll = this.onScroll.bind(this);
      this.onKeydown = this.onKeydown.bind(this);
      this.onPointerDown = this.onPointerDown.bind(this);
      this.onPointerMove = this.onPointerMove.bind(this);
      this.onPointerUp = this.onPointerUp.bind(this);

      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      this.track.addEventListener('keydown', this.onKeydown);
      this.track.addEventListener('pointerdown', this.onPointerDown);

      if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.go(-1));
      if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.go(1));

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => this.goToIndex(Number(dot.dataset.index)));
      });

      this.updateActive();
    }

    disconnectedCallback() {
      this.track.removeEventListener('scroll', this.onScroll);
      this.track.removeEventListener('keydown', this.onKeydown);
      this.track.removeEventListener('pointerdown', this.onPointerDown);
      window.removeEventListener('pointermove', this.onPointerMove);
      window.removeEventListener('pointerup', this.onPointerUp);
    }

    currentIndex() {
      return Math.round(this.track.scrollLeft / this.track.clientWidth);
    }

    go(delta) {
      this.goToIndex(this.currentIndex() + delta);
    }

    goToIndex(index) {
      const clamped = Math.max(0, Math.min(this.slides.length - 1, index));
      this.track.scrollTo({
        left: clamped * this.track.clientWidth,
        behavior: 'smooth',
      });
    }

    onScroll() {
      window.clearTimeout(this._scrollTimeout);
      this._scrollTimeout = window.setTimeout(() => this.updateActive(), 80);
    }

    updateActive() {
      const index = this.currentIndex();
      this.slides.forEach((slide, i) => {
        slide.setAttribute('aria-hidden', i === index ? 'false' : 'true');
      });
      this.dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === index);
        dot.setAttribute('aria-selected', i === index ? 'true' : 'false');
      });
    }

    onKeydown(event) {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        this.go(-1);
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        this.go(1);
      }
    }

    onPointerDown(event) {
      if (event.pointerType !== 'mouse') return;
      this.isDragging = true;
      this.dragMoved = false;
      this.dragStartX = event.clientX;
      this.dragStartScroll = this.track.scrollLeft;
      this.track.classList.add('is-dragging');
      window.addEventListener('pointermove', this.onPointerMove);
      window.addEventListener('pointerup', this.onPointerUp);
    }

    onPointerMove(event) {
      if (!this.isDragging) return;
      const delta = event.clientX - this.dragStartX;
      if (Math.abs(delta) > 4) this.dragMoved = true;
      this.track.scrollLeft = this.dragStartScroll - delta;
    }

    onPointerUp() {
      if (!this.isDragging) return;
      this.isDragging = false;
      this.track.classList.remove('is-dragging');
      window.removeEventListener('pointermove', this.onPointerMove);
      window.removeEventListener('pointerup', this.onPointerUp);
      this.goToIndex(this.currentIndex());
    }
  }

  customElements.define('ls-milestone-carousel', LsMilestoneCarousel);

  } catch(e) { console.error(e); }
})();
})();
